import Container from './ForumPostModal.container';
import ForumPostModal from './ForumPostModal';

export default Container(ForumPostModal);
